var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.1113C24 5.48391 18.6274 0.111328 12 0.111328C5.37258 0.111328 0 5.48391 0 12.1113C0 18.1008 4.3882 23.0653 10.125 23.9655V15.5801H7.07812V12.1113H10.125V9.46758C10.125 6.46008 11.9166 4.79883 14.6576 4.79883C15.9701 4.79883 17.3438 5.0332 17.3438 5.0332V7.98633H15.8306C14.34 7.98633 13.875 8.91141 13.875 9.86133V12.1113H17.2031L16.6711 15.5801H13.875V23.9655C19.6118 23.0653 24 18.1008 24 12.1113Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.111328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookImg);
export default __webpack_public_path__ + "static/media/facebook-img.bdd4e5b77b0f1492ddc743671758ec2a.svg";
export { ForwardRef as ReactComponent };